import React from "react"
import { useRoutes } from "react-router-dom"

import LayoutCommon from "src/components/Common/LayoutCommon"
import SpinCustom from "src/components/SpinCustom"
import OrganizationContact from "src/pages/ADMIN/OrganizationContact"
import Contact from "src/pages/ANONYMOUS/Contact"
import AssociationRegistration from "src/pages/USER/AssociationRegistration"
import JoinedOrganizations from "src/pages/USER/JoinedOrganizations"
import ROUTER from "./ROUTER"

// common
const PublicRouters = React.lazy(
  () => import("src/pages/SUPPORTPAGES/PublicRouters"),
)
const SvgViewer = React.lazy(() => import("src/pages/SUPPORTPAGES/SvgViewer"))
const Receiver = React.lazy(() => import("src/pages/SUPPORTPAGES/Receiver"))

const NotFound = React.lazy(() => import("src/pages/SUPPORTPAGES/NotFound"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/Home"))
const PrivateRoutes = React.lazy(
  () => import("src/pages/SUPPORTPAGES/PrivateRoutes"),
)
const AminRoutes = React.lazy(() => import("src/pages/SUPPORTPAGES/AminRoutes"))
const ScanQR = React.lazy(() => import("src/pages/SUPPORTPAGES/ScanQRInfo"))
const MemberByQr = React.lazy(() => import("src/pages/SUPPORTPAGES/MemberInfo"))

const MemberCardPage = React.lazy(
  () => import("src/pages/SUPPORTPAGES/ScanQRInfo/pages/MemberCardPage"),
)
//Mạng xã hội

const LoginGoogle = React.lazy(
  () => import("src/pages/SUPPORTPAGES/LoginGoogle"),
)

// ANONYMOUS
const TermsPage = React.lazy(
  () => import("src/pages/ANONYMOUS/TermsConditions"),
)
const GroupList = React.lazy(() => import("src/pages/ANONYMOUS/GroupList"))
const MemberRights = React.lazy(
  () => import("src/pages/ANONYMOUS/MemberRights"),
)
const GroupListDetail = React.lazy(
  () => import("src/pages/ANONYMOUS/GroupList/components/GroupListDetail"),
)
const AdRegistration = React.lazy(
  () => import("src/pages/ANONYMOUS/AdRegistration"),
)
const LoginLink = React.lazy(() => import("src/pages/ANONYMOUS/LoginLink"))

// USER
// const MyAccount = React.lazy(() => import("src/pages/USER/MyAccount"))
const MemberInfo = React.lazy(() => import("src/pages/USER/MemberInfo"))
const CertiPage = React.lazy(
  () => import("src/pages/SUPPORTPAGES/CertificationPage/CertificatePage"),
)

const UpgradePackage = React.lazy(() => import("src/pages/USER/UpgradePackage"))
const ListRequestSupport = React.lazy(
  () => import("src/pages/USER/Support/components/ListRequestSupport.jsx"),
)
const PaymentHistory = React.lazy(
  () => import("src/pages/USER/MembershipFees/components/PaymentHistory"),
)
const UnPaidFees = React.lazy(
  () => import("src/pages/USER/MembershipFees/components/UnpaidFees"),
)
const BusinessRegistration = React.lazy(
  () => import("src/pages/USER/BusinessRegistration"),
)
const BusinessRegistration2 = React.lazy(
  () => import("src/pages/USER/BusinessRegistration2"),
)
const IndividualRegistration = React.lazy(
  () => import("src/pages/USER/IndividualRegistration"),
)
const AdvertisementRegistraion = React.lazy(
  () => import("src/pages/USER/AdvertisementRegistraion"),
)
const ManageAdvertisementRegistraion = React.lazy(
  () => import("src/pages/USER/ManageAdvertisementRegistraion"),
)

// ADMIN
const OverView = React.lazy(() => import("src/pages/ADMIN/OverView"))
const Role = React.lazy(() => import("src/pages/ADMIN/Role"))
const Position = React.lazy(() => import("src/pages/ADMIN/Position"))
const UnitContacts = React.lazy(() => import("src/pages/ADMIN/UnitContacts"))

const GroupUnitContacts = React.lazy(
  () => import("src/pages/ADMIN/GroupUnitContacts"),
)
const AdvertisementApproval = React.lazy(
  () => import("src/modules/advertisement/pages/AdvertisementApproval"),
)

const ListContact = React.lazy(() => import("src/pages/ADMIN/ListContact"))
const RevenueExpenditure = React.lazy(
  () => import("src/pages/ADMIN/RevenueExpenditure"),
)
const ListExpenditure = React.lazy(
  () => import("src/pages/ADMIN/ListExpenditure"),
)
const ListMembership = React.lazy(
  () => import("src/pages/ADMIN/ListMembership"),
)
const MemberContact = React.lazy(() => import("src/pages/ADMIN/MemberContact"))
const Association = React.lazy(() => import("src/pages/ADMIN/Association"))
const MembershipPackage = React.lazy(
  () => import("src/pages/ADMIN/MembershipPackage"),
)
const MembershipType = React.lazy(
  () => import("src/pages/ADMIN/MembershipType"),
)
const MemberStatistics = React.lazy(
  () => import("src/pages/ADMIN/MemberStatistics"),
)

const AssociationApproval = React.lazy(
  () => import("src/pages/ADMIN/AssociationApproval"),
)
const ApprovalJoin = React.lazy(() => import("src/pages/ADMIN/ApprovalJoin"))
const ApprovedLeaveAssociation = React.lazy(
  () => import("src/pages/ADMIN/ApprovedLeaveAssociation"),
)
const ComplaintHandling = React.lazy(
  () => import("src/pages/ADMIN/ComplaintHandling"),
)
const NotificationManagement = React.lazy(
  () => import("src/pages/ADMIN/NotificationManagement"),
)

const RequestSupport = React.lazy(
  () => import("src/pages/ADMIN/RequestSupport"),
)

const AdvertisingPackage = React.lazy(
  () => import("src/pages/ADMIN/AdvertisingPackage"),
)
const AdvertismentSuggestion = React.lazy(
  () => import("src/pages/USER/AdvertismentSuggestion"),
)
function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <SpinCustom fullscreen />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}
const routes = [
  {
    path: ROUTER.CHUNG_NHAN_HOI_VIEN,
    element: (
      <LazyLoadingComponent>
        <CertiPage />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.MEMBER_CARD,
    element: (
      <LazyLoadingComponent>
        <MemberCardPage />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.SCAN_QR,
    element: (
      <LazyLoadingComponent>
        <ScanQR />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.MEMBER_INFO,
    element: (
      <LazyLoadingComponent>
        <MemberByQr />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.LOGIN_GOOGLE,
    element: (
      <LazyLoadingComponent>
        <LoginGoogle />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.RECEIVER,
    element: (
      <LazyLoadingComponent>
        <Receiver />
      </LazyLoadingComponent>
    ),
  },

  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.TONG_QUAN,
        element: (
          <LazyLoadingComponent>
            <OverView />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHE_DUYET_THU_CHI,
        element: (
          <LazyLoadingComponent>
            <RevenueExpenditure />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_THU_CHI,
        element: (
          <LazyLoadingComponent>
            <ListExpenditure />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_HOI_PHI,
        element: (
          <LazyLoadingComponent>
            <ListMembership />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <MemberContact />
          </LazyLoadingComponent>
        ),
      },
      //-donvi
      {
        path: ROUTER.QUAN_LY_DON_VI,
        element: (
          <LazyLoadingComponent>
            <OrganizationContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_HIEP_HOI,
        element: (
          <LazyLoadingComponent>
            <Association />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHE_DUYET_HIEP_HOI,
        element: (
          <LazyLoadingComponent>
            <AssociationApproval />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_QUYEN_LOI,
        element: (
          <LazyLoadingComponent>
            <MembershipPackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_LOAI_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <MembershipType />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <MemberStatistics />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DUYET_GIA_NHAP,
        element: (
          <LazyLoadingComponent>
            <ApprovalJoin />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DUYET_ROI_HOI,
        element: (
          <LazyLoadingComponent>
            <ApprovedLeaveAssociation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.XU_LY_KHIEU_NAI,
        element: (
          <LazyLoadingComponent>
            <ComplaintHandling />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.XU_LY_YEU_CAU_HO_TRO,
        element: (
          <LazyLoadingComponent>
            <RequestSupport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_THONG_BAO,
        element: (
          <LazyLoadingComponent>
            <NotificationManagement />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANH_BA_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <ListContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_PHAN_QUYEN,
        element: (
          <LazyLoadingComponent>
            <Role />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_GOI_QUANG_CAO,
        element: (
          <LazyLoadingComponent>
            <AdvertisingPackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHUC_VU,
        element: (
          <LazyLoadingComponent>
            <Position />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_DON_VI,
        element: (
          <LazyLoadingComponent>
            <UnitContacts />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NHOM_DON_VI,
        element: (
          <LazyLoadingComponent>
            <GroupUnitContacts />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHE_DUYET_QUANG_CAO,
        element: (
          <LazyLoadingComponent>
            <AdvertisementApproval />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.THONG_TIN_TAI_KHOAN,
        element: (
          <LazyLoadingComponent>
            <MemberInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.NANG_CAP_GOI_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <UpgradePackage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHI_CHUA_DONG,
        element: (
          <LazyLoadingComponent>
            <UnPaidFees />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LICH_SU_DONG_PHI,
        element: (
          <LazyLoadingComponent>
            <PaymentHistory />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANH_SACH_YEU_CAU_HO_TRO,
        element: (
          <LazyLoadingComponent>
            <ListRequestSupport />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_HOI_THAM_GIA,
        element: (
          <LazyLoadingComponent>
            <JoinedOrganizations />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_HIEP_HOI,
        element: (
          <LazyLoadingComponent>
            <AssociationRegistration />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DE_XUAT_QUANG_CAO,
        element: (
          <LazyLoadingComponent>
            <AdvertismentSuggestion />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_QUANG_CAO,
        element: (
          <LazyLoadingComponent>
            <AdvertisementRegistraion />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DON_DANG_KY_QUANG_CAO,
        element: (
          <LazyLoadingComponent>
            <ManageAdvertisementRegistraion />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KI_DOANH_NGHIEP,
        element: (
          <LazyLoadingComponent>
            <BusinessRegistration />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY_QUANG_CAO_KHACH,
        element: (
          <LazyLoadingComponent>
            <AdRegistration />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.DANG_KI_DOANH_NGHIEP}2`,
        element: (
          <LazyLoadingComponent>
            <BusinessRegistration2 />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KI_CA_NHAN,
        element: (
          <LazyLoadingComponent>
            <IndividualRegistration />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DIEU_KIEN_VA_THU_TUC,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <TermsPage />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANH_SACH_HOI_NHOM,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <GroupList />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUYEN_LOI_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <MemberRights />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LIEN_HE_HO_TRO,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <Contact />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_NHAP_LINK,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <LoginLink />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
      {
        path: "hoi-nhom-chi-tiet/:id",
        element: (
          <LazyLoadingComponent>
            <GroupListDetail />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUYEN_LOI_HOI_VIEN,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <MemberRights />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LIEN_HE_HO_TRO,
        element: (
          <LazyLoadingComponent>
            <LayoutCommon>
              <Contact />
            </LayoutCommon>
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
